import { useLayoutEffect } from 'react'

export const ABHA_HERO_MODAL_OPEN_CLASS = 'abha-hero-modal-open'

let activeBodyScrollLocks = 0
let pendingUnlockFrame: number | undefined

const clearScrollLockStyles = () => {
  document.documentElement.style.overflow = ''
  document.documentElement.style.overflowY = ''
  document.body.style.overflow = ''
  document.body.style.overflowY = ''
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.width = ''
}

const removeScrollLockClass = () => {
  document.documentElement.classList.remove(ABHA_HERO_MODAL_OPEN_CLASS)
  document.body.classList.remove(ABHA_HERO_MODAL_OPEN_CLASS)
}

const acquireBodyScrollLock = () => {
  if (pendingUnlockFrame !== undefined) {
    window.cancelAnimationFrame(pendingUnlockFrame)
    pendingUnlockFrame = undefined
  }

  activeBodyScrollLocks += 1
  document.documentElement.classList.add(ABHA_HERO_MODAL_OPEN_CLASS)
  document.body.classList.add(ABHA_HERO_MODAL_OPEN_CLASS)
  document.documentElement.style.overflowY = 'hidden'
  document.body.style.overflowY = 'hidden'
}

const releaseBodyScrollLock = () => {
  activeBodyScrollLocks = Math.max(0, activeBodyScrollLocks - 1)

  if (activeBodyScrollLocks > 0) return

  pendingUnlockFrame = window.requestAnimationFrame(() => {
    pendingUnlockFrame = undefined
    if (activeBodyScrollLocks > 0) return

    removeScrollLockClass()
    clearScrollLockStyles()
  })
}

/** Locks background page scroll while the ABHA modal is open. */
export const useBodyScrollLock = (locked: boolean) => {
  useLayoutEffect(() => {
    if (!locked) return undefined

    acquireBodyScrollLock()

    const preventBackgroundScroll = (event: Event) => {
      const target = event.target

      if (target instanceof Node && document.querySelector('.abha-hero-modal')?.contains(target)) {
        return
      }

      event.preventDefault()
    }

    window.addEventListener('wheel', preventBackgroundScroll, { passive: false })
    window.addEventListener('touchmove', preventBackgroundScroll, { passive: false })

    return () => {
      window.removeEventListener('wheel', preventBackgroundScroll)
      window.removeEventListener('touchmove', preventBackgroundScroll)
      releaseBodyScrollLock()
    }
  }, [locked])
}
